<template>
    <g>
        <path style="fill:#7F1919;" d="M58.3,59.7l-2.5,0.1l-2.1,0.5l0,0.2c0,0,0,0,0,0l0-0.2l-2.1-0.5l-2.5-0.1l-0.9-0.2l0.3,0.6l3.7,2.9l1.4,0.3
	l0-0.2c0,0,0,0,0.1,0l0,0.2l1.4-0.3l3.7-2.9l0.3-0.6L58.3,59.7z"/>
        <path style="fill:#FFFFFF;" d="M53.7,60.4l-4.4-0.5c0,0.1,0.3,0.8,0.3,0.8s1.3,1.9,4.1,2.3h0c2.8-0.4,4.1-2.3,4.1-2.3s0.3-0.7,0.3-0.8
	L53.7,60.4z"/>
        <path style="fill:#E53C3C;" d="M59,59.6c0,0-1.6,1.3-2.7,2.1c-1,0.8-2.5,0.7-2.6,0.7l0,0c0,0,0,0,0,0c0,0,0,0,0,0l0,0c-0.1,0-1.6,0.1-2.6-0.7
	c-1.1-0.8-2.7-2.1-2.7-2.1l-0.7-0.3c0,0,2.2,3.4,3.3,4c1.1,0.5,1.2,0.7,2.7,0.7h0c1.5,0,1.6-0.2,2.7-0.7c1.1-0.5,3.3-4,3.3-4
	L59,59.6z"/>
        <path style="fill:#BF1D1D;" d="M59.7,59.3c0,0-1.7,0.3-2.4,0.2c-0.7-0.1-1.1-0.1-1.6-0.1s-1.5,0.5-1.9,0.5h0c-0.5,0-1.4-0.4-1.9-0.5
	s-1,0-1.6,0.1c-0.7,0.1-2.4-0.2-2.4-0.2l1,0.4c2.1,1,4.8,1,5,1v0c0,0,0,0,0,0c0,0,0,0,0,0v0c0.2,0,2.9,0,5-1L59.7,59.3z"/>
    </g>
</template>

<script>
    import Mouth from './Mouth';

    export default {
        name: 'Mouth12',
        mixins: [Mouth],
    }
</script>
